module.exports = __webpack_public_path__ + "img/Group 20.69d0a6d7.svg";